import ISectionCondition, {
  ComponentProp,
  IComponentValue,
  OperatorType,
} from '@components/FormFlow/Interfaces/ISectionCondition';
import { faPlus, faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { ComponentType } from '@interfaces/component-type';
import AppContext from '@services/Context';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Col, DatePicker, Input, InputNumber, Modal, Radio, Row, Select } from 'antd';
import pt_BR from 'antd/lib/locale-provider/pt_BR';
import moment from 'moment';
import React from 'react';

import ProcessContext from './ProcessContext';


const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const Option = Select.Option;
let validationConditions: boolean[] = []
class ConditionRules {
  xItem: IComponentValue;
  operator: OperatorType;
  value?: any;

  constructor() {
    this.operator = 3;
    this.value = undefined;
    this.xItem = {
      id: '',
      prop: ComponentProp.VALUE
    };

    return this;
  }
}

class conditionsPage {
  id: string | undefined;
  rules: any;
  sectionId: string | undefined;
  invalid: boolean;

  constructor() {
    this.id = Math.random().toString(36).substr(2, 9);
    this.rules = [new ConditionRules()];
    this.sectionId = undefined;
    this.invalid = false;
    return this;
  }
}

interface IConditionProcessPropType {
  modalVisible: boolean;
  onCloseModal: Function;
  titleConditionModal: string;
  subtitleConditionModal: string;
  currentPage: any
};
interface IConditionProcessStateType {
  nextPage?: string;
  conditions?: any;
  currentPage: any;
  validationConditions: boolean[]
  forceNext: boolean;
};

export default class ConditionsProcess extends React.Component<IConditionProcessPropType, IConditionProcessStateType> {
  constructor(props: IConditionProcessPropType) {
    super(props);
    this.state = {
      nextPage: this.props.currentPage.next || undefined,
      currentPage: this.props.currentPage || [],
      conditions: this.props.currentPage.conditions || [],
      validationConditions: [],
      forceNext: false
    }
  }

  componentDidMount = async () => {
    if (!this.state.currentPage.next) {
      const newPage = Object.assign(this.state.currentPage)
      newPage.next = 'end'
      this.setState({ currentPage: this.state.currentPage })
    }
  }

  getPages(pages: any, currentPage: any) {
    const selectItems: string[] = [];
    const options: JSX.Element[] = []

    for (let items of pages) {
      if (items.id) {
        selectItems.push(items);
      }
      const indexSelectSection = selectItems.findIndex((idTitle: any) => idTitle.id === currentPage.id)
      if (indexSelectSection > -1) {
        selectItems.splice(indexSelectSection)
      }
    }
    selectItems.map((page: any, index: number) => (
      options.push(
        <Option key={index} value={page.id}>
          {page.title}
        </Option>
      )
    ))
    return options;
  }

  onNextPageChange = async (evt: any) => {
    this.setState({
      nextPage: evt,
      forceNext: true
    })
  }

  onClickNewCondition = async () => {
    this.setState({ conditions: this.state.conditions.concat([new conditionsPage()]) })
  }

  handleRemoveCondition = (index: number) => async () => {
    this.setState({
      conditions: this.state.conditions.filter((page: any, sindex: number) => index !== sindex),
    });
  }

  handleRemoveRules = (idxCondition: number, idxRule: number, rules: any) => async () => {
    const newRules = Object.assign({}, this.state.conditions);
    newRules[idxCondition].rules = rules.filter((section: any, sindex: number) => idxRule !== sindex)

    this.setState({ conditions: this.state.conditions });
  }

  handleAddNewRules = async (rulesCondition: any, idx: number) => {
    const newRules = Object.assign(this.state.conditions);
    newRules[idx].rules = rulesCondition.concat(new ConditionRules())
    this.setState({ conditions: this.state.conditions })
  }


  onChangeSelectComponetCondition = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditions);
    newRules[idxCondition].rules[idxRule].xItem.id = evt
    newRules[idxCondition].rules[idxRule].value = undefined
    if (newRules[idxCondition].rules[idxRule].xItem.id !== "") {
      newRules[idxCondition].rules[idxRule].xItemInvalid = false
    }
    this.setState({
      conditions: this.state.conditions,
    })
  }

  onChangeSelectLinkCondition = (idx: any) => async (evt: any) => {
    const newCondition = Object.assign(this.state.conditions[idx])
    newCondition.sectionId = evt
    if (newCondition.sectionId !== undefined) {
      newCondition.invalid = false;
    }
    this.setState({
      conditions: this.state.conditions,
    });
  }

  onChangeOperator = (idxCondition: any, idxRule: number) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditions);
    newRules[idxCondition].rules[idxRule].operator = evt
    this.setState({ conditions: this.state.conditions })
  }

  onChangeValue = (idxCondition: any, idxRule: number, type: ComponentType) => async (evt: any) => {
    const newRules = Object.assign({}, this.state.conditions);
    if (type === ComponentType.TEXT || type === ComponentType.NUMBER || type === ComponentType.CONFIRM) {
      newRules[idxCondition].rules[idxRule].value = evt.target.value
    }
    if (type === ComponentType.DATE) {
      newRules[idxCondition].rules[idxRule].value = evt.toDate().getTime()
    }
    if (type === ComponentType.SELECT) {
      newRules[idxCondition].rules[idxRule].value = evt
    }
    if (newRules[idxCondition].rules[idxRule].value !== undefined) {
      newRules[idxCondition].rules[idxRule].valueInvalid = false
      this.setState({ conditions: this.state.conditions })
    }
  }

  getConditionComponents = (currentPage: any) => {
    const conditionsComponent: JSX.Element[] = [];
    for (let [idx, component] of currentPage.components.entries()) {
      if (
        component.type !== ComponentType.GPS &&
        component.type !== ComponentType.MODEL &&
        component.type !== ComponentType.SAMPLETEXT &&
        component.type !== ComponentType.SAMPLEIMAGE &&
        component.type !== ComponentType.SAMPLEVIDEO &&
        component.type !== ComponentType.AUDIO &&
        component.type !== ComponentType.DRAW &&
        component.type !== ComponentType.PHOTO
      ) {
        conditionsComponent.push(
          <Option key={idx} value={component.id}>
            {component.title}
          </Option>
        );
      }
    }
    return conditionsComponent;
  }

  getOperatorCondition = (rulesItems: any, idxCondition: number, idxRule: number, type: ComponentType) => {
    switch (type) {
      case ComponentType.NUMBER:
        return (
          <Select
            disabled={rulesItems.xItem.id ? false : true}
            value={rulesItems.operator}
            style={{ width: '160px', marginLeft: '8px' }}
            onChange={this.onChangeOperator(idxCondition, idxRule)}
          // getPopupContainer={() => document.getElementById("area")}
          >
            <Option value={OperatorType.Equals}>{I18n.l("formflow.conditions.equals")}</Option>
            <Option value={OperatorType.GreaterThan}>{I18n.l("formflow.conditions.greaterThan")} </Option>
            <Option value={OperatorType.GreaterOrEqualsThan}>{I18n.l("formflow.conditions.greaterThanOrEquals")}</Option>
            <Option value={OperatorType.LessThan}>{I18n.l("formflow.conditions.lessThan")} </Option>
            <Option value={OperatorType.LessOrEqualsThan}>{I18n.l("formflow.conditions.lessThanOrEquals")}</Option>
            <Option value={OperatorType.NotEquals}>{I18n.l("formflow.conditions.notEquals")}</Option>
          </Select>
        );
      case ComponentType.SELECT:
        return (
          <Select
            disabled={rulesItems.xItem.id ? false : true}
            value={rulesItems.operator}
            style={{ width: '160px', marginLeft: '8px' }}
            onChange={this.onChangeOperator(idxCondition, idxRule)}
          >
            <Option value={OperatorType.Equals}>{I18n.l("formflow.conditions.equals")}</Option>
            <Option value={OperatorType.NotEquals}>{I18n.l("formflow.conditions.notEquals")}</Option>
          </Select>
        );
      case ComponentType.CONFIRM:
        return (
          <Select
            disabled={rulesItems.xItem.id ? false : true}
            value={rulesItems.operator}
            style={{ width: '160px', marginLeft: '8px' }}
            onChange={this.onChangeOperator(idxCondition, idxRule)}
          >
            <Option value={OperatorType.Equals}>{I18n.l("formflow.conditions.equals")}</Option>
          </Select>
        );
      default:
        return (
          <Select
            disabled={rulesItems.xItem.id ? false : true}
            value={rulesItems.operator}
            style={{ width: '160px', marginLeft: '8px' }}
            onChange={this.onChangeOperator(idxCondition, idxRule)}
          >
            <Option value={OperatorType.Equals}>{I18n.l("formflow.conditions.equals")} </Option>
            <Option value={OperatorType.NotEquals}>{I18n.l("formflow.conditions.notEquals")}</Option>
            <Option value={OperatorType.Contains}>{I18n.l("formflow.conditions.contains")}</Option>
            <Option value={OperatorType.NotContains}>{I18n.l("formflow.conditions.notContains")}</Option>
          </Select>
        );
    }
  }

  renderConditionComponent(rulesItems: any, idxCondition: number, idxRule: number) {
    const currentComponentCondition: any = this.props.currentPage.components.find((x: any) => (x.id === rulesItems.xItem.id))
    if (currentComponentCondition !== undefined) {
      switch (currentComponentCondition.type) {
        case (ComponentType.NUMBER || ComponentType.SCORE || ComponentType.CALCULATOR):
          return (
            <>
              {this.getOperatorCondition(rulesItems, idxCondition, idxRule, ComponentType.NUMBER)}
              <InputNumber
                disabled={rulesItems.xItem.id ? false : true}
                defaultValue={rulesItems.value}
                style={{ width: '160px', marginLeft: '8px' }}
                placeholder={I18n.l("process.conditions.insertValue")}
                onBlur={this.onChangeValue(idxCondition, idxRule, ComponentType.NUMBER)}
                className={rulesItems.valueInvalid ? 'select-invalid' : ""}
              />
            </>
          );
        case ComponentType.SELECT:
          return (
            <>
              {this.getOperatorCondition(rulesItems, idxCondition, idxRule, ComponentType.SELECT)}
              <Select
                disabled={rulesItems.xItem.id ? false : true}
                defaultValue={rulesItems.value}
                style={{ width: '160px', marginLeft: '8px' }}
                placeholder={I18n.l("process.conditions.insertValue")}
                onChange={this.onChangeValue(idxCondition, idxRule, ComponentType.SELECT)}
                className={rulesItems.valueInvalid ? 'select-invalid' : ""}
              >
                {currentComponentCondition.options.map((items: any, idx: number) => (
                  <Option key={idx} value={idx}>{items.value}</Option>
                ))}
              </Select>
            </>
          );

        case ComponentType.CONFIRM:
          return (
            <>
              {this.getOperatorCondition(rulesItems, idxCondition, idxRule, ComponentType.CONFIRM)}
              <RadioGroup
                onChange={this.onChangeValue(idxCondition, idxRule, ComponentType.CONFIRM)}
                defaultValue={rulesItems.value}
                style={{ marginLeft: '8px' }}
                className={rulesItems.valueInvalid ? 'select-invalid' : ""}
              >
                <RadioButton value={true}>{currentComponentCondition.yesLabel.toUpperCase()}</RadioButton>
                <RadioButton value={false}>{currentComponentCondition.noLabel.toUpperCase()}</RadioButton>
              </RadioGroup>
            </>
          );

        case ComponentType.DATE:
          return (
            <>
              {this.getOperatorCondition(rulesItems, idxCondition, idxRule, ComponentType.NUMBER)}
              <AppContext.Consumer>
                {({ locale }) => (
                  <DatePicker
                    disabled={rulesItems.xItem.id ? false : true}
                    showToday={false}
                    style={{ width: '160px', marginLeft: '8px' }}
                    format={I18n.l('common.dateFormat')}
                    locale={(locale === "pt") ? pt_BR.DatePicker : undefined}
                    onChange={this.onChangeValue(idxCondition, idxRule, ComponentType.DATE)}
                    defaultValue={rulesItems.value ? moment(rulesItems.value) : undefined}
                    className={rulesItems.valueInvalid ? 'select-invalid' : ""}
                    placeholder={I18n.l('label.datePlaceholder')}
                  />
                )}
              </AppContext.Consumer>
            </>
          );

        default:
          return (
            <>
              {this.getOperatorCondition(rulesItems, idxCondition, idxRule, ComponentType.TEXT)}
              <Input
                disabled={rulesItems.xItem.id ? false : true}
                defaultValue={rulesItems.value}
                style={{ width: '160px', marginLeft: '8px' }}
                placeholder={I18n.l("process.conditions.insertValue")}
                onBlur={this.onChangeValue(idxCondition, idxRule, ComponentType.TEXT)}
                className={rulesItems.valueInvalid ? 'select-invalid' : ""}
              // getPopupContainer={() => document.getElementById("area")}
              />
            </>
          );
      }
    } else {
      return (
        <>
          {this.getOperatorCondition(rulesItems, idxCondition, idxRule, ComponentType.TEXT)}
          <Input
            disabled={rulesItems.xItem.id ? false : true}
            defaultValue={rulesItems.value}
            style={{ width: '160px', marginLeft: '8px' }}
            placeholder={I18n.l("process.conditions.insertValue")}
            onChange={this.onChangeValue(idxCondition, idxRule, ComponentType.TEXT)}
          />
        </>
      );
    }
  }

  onSaveCondition = async (updateProcessCondition: (condition: any, elseLink?: string, forceNext?: boolean) => void) => {
    const newConditions = Object.assign(this.state.conditions)
    if (this.state.nextPage === 'end') {
      this.setState({ nextPage: undefined })
    }
    for (let [idxConditions, items] of this.state.conditions.entries()) {
      if (items.sectionId !== undefined) {
        this.setState({ validationConditions: [] })
      }
      if (items.sectionId === undefined) {
        newConditions[idxConditions].invalid = true;
        validationConditions.push(false)
        this.setState({ validationConditions: validationConditions })
      }
      for (let [idxRule, rule] of items.rules.entries()) {
        if (rule.xItem.id === "") {
          newConditions[idxConditions].rules[idxRule].xItemInvalid = true;
          validationConditions.push(false)
          this.setState({ validationConditions: validationConditions })
        }
        if (rule.xItem.id !== "" && (rule.value === undefined || rule.value.length === 0)) {
          newConditions[idxConditions].rules[idxRule].valueInvalid = true;
          validationConditions.push(false)
          this.setState({ validationConditions: validationConditions })
        }
      }
    }
    this.setState({ conditions: this.state.conditions })
    if (this.state.validationConditions.length === 0 || this.state.conditions.length === 0) {
      updateProcessCondition(this.state.conditions, this.state.nextPage, this.state.forceNext);
      this.props.onCloseModal()
    }
    else {
      NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('process.execution.fieldsNotFilled'));
    }
  }



  render() {
    const {
      modalVisible,
      titleConditionModal,
    } = this.props;
    return (
      <Wrapper>
        <ProcessContext.Consumer>
          {({ pages, currentPage, updateProcessCondition }) => (
            <Modal
              className="section-condition-fullscreen"
              destroyOnClose={true}
              footer={false}
              visible={modalVisible}
              closable={false}
            >
              <NextPageStyle>
                <h1 className="title-style">{I18n.l('process.conditions.flowPage')}</h1>
                <h1 className='name-page-style'>{titleConditionModal}</h1>
                {(this.state.conditions === undefined || this.state.conditions.length === 0) &&
                  <>
                    <p className='next-page-style' >
                      <span>{I18n.l('process.condition.nextPage')}</span>
                      <span style={{ fontWeight: 'bold' }}>{I18n.l('process.condition.alwaysGo')} </span>
                      <span>{I18n.l('process.condition.goto')}</span>
                      <Select
                        defaultValue={this.state.currentPage.next}
                        placeholder={I18n.l('label.selectPage')}
                        style={{ width: '253px' }}
                        onChange={this.onNextPageChange}
                      >
                        {this.getPages(pages, currentPage)}
                        <Option value="end">{I18n.l("formflow.labels.finishSection")}</Option>
                      </Select>
                    </p>
                    <Divider />
                    <p className='condition-description'>{I18n.l('process.condition.description')}</p>
                    <Button onClick={this.onClickNewCondition} size='large' >{I18n.l('formflow.buttons.addNewCondition').toUpperCase()}</Button>
                  </>
                }
              </NextPageStyle>
              <ConditionStyle>
                {(this.state.conditions && this.state.conditions.length > 0) &&
                  <>
                    {this.state.conditions.map((items: any, idx: number) => (
                      <>
                        <div key={items.id} className='item-container-condition condition-title-style'>
                          {I18n.l('process.conditionTitle') + ' ' + (idx + 1)}
                          {items.rules.map((rulesItems: any, idxRules: number) => (
                            <div key={Math.random().toString(36).substr(2, 9)} className='rules-conditions-box'>
                              <span>{I18n.l("process.conditions.answerInsert")}</span>
                              {/* Select component */}
                              <Select
                                value={rulesItems.xItem.id ? rulesItems.xItem.id : undefined}
                                style={{ width: '250px', marginLeft: '8px' }}
                                placeholder={I18n.l("formflow.labels.selectComponentConditionPlaceholder")}
                                onChange={this.onChangeSelectComponetCondition(idx, idxRules)}
                                className={rulesItems.xItemInvalid ? 'select-invalid' : ""}
                              >
                                {this.getConditionComponents(currentPage)}
                              </Select>
                              {/* Input value */}
                              {this.renderConditionComponent(items.rules[idxRules], idx, idxRules)}
                              {items.rules.length > 1 &&
                                <span className='remove-conditions-style' onClick={this.handleRemoveRules(idx, idxRules, items.rules)}>
                                  <Icon style={{ marginRight: '8px' }} icon={faTrash} />
                                  {I18n.l('common.delete')}
                                </span>
                              }
                              {(rulesItems.xItemInvalid === true || rulesItems.valueInvalid === true) &&
                                <div style={rulesItems.xItemInvalid ? { color: `${Theme.secondary.red}`, fontWeight: 'bold', marginLeft: '167px' } : { color: `${Theme.secondary.red}`, fontWeight: 'bold', marginLeft: '595px' }} >{I18n.l("form.validation.field.required")}</div>
                              }
                            </div>
                          ))}
                          <Row className='add-new-rule-style'>
                            <Col onClick={this.onClickNewCondition} span={2} >
                              <Icon color='#1890ff' style={{ fontSize: '20px' }} icon={faPlus} />
                            </Col>
                            <Col onClick={() => this.handleAddNewRules(items.rules, idx)} className='add-button-style' span={21} >
                              {I18n.l('process.conditions.addNewRule')}
                            </Col>
                          </Row>
                          <div className='divider-condition ' />
                          <div className='footer-condition-style'>
                            <span>{I18n.l("formflow.labels.nextSectionSelect")}</span>
                            <Select
                              style={{ width: '20%', marginLeft: '8px', fontWeight: 'normal' }}
                              placeholder={I18n.l("label.selectPage")}
                              onChange={this.onChangeSelectLinkCondition(idx)}
                              value={items.sectionId}
                              className={items.invalid ? 'select-invalid' : ""}
                            >
                              {this.getPages(pages, currentPage)}
                            </Select>

                            <span className='remove-conditions-style' onClick={this.handleRemoveCondition(idx)}>
                              <Icon style={{ marginRight: '8px' }} icon={faTrash} />
                              {I18n.l('process.lite.removeConditionTitle')}
                            </span>
                            {items.invalid === true &&
                              <div style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold', marginLeft: '55px' }} >{I18n.l("form.validation.field.required")}</div>
                            }
                          </div>
                        </div>
                      </>
                    ))}
                    <Divider>
                      <Row className='cursor-page-style'>
                        <Col onClick={this.onClickNewCondition} span={7} >
                          <Icon color=' #1890ff' size='3x' icon={faPlusCircle} />
                        </Col>
                        <Col onClick={this.onClickNewCondition} className='add-button-style' span={16} >
                          {I18n.l('formflow.buttons.addNewCondition')}
                        </Col>
                      </Row>
                    </Divider>
                    <div className='item-container-condition' id="area">
                      <span style={{ marginRight: ' 5px' }} className='choose-next-style' >{I18n.l("label.conditions.else")}</span>
                      <Select
                        defaultValue={this.state.currentPage.next}
                        style={{ width: '20%' }}
                        placeholder={I18n.l("label.selectPage")}
                        key={1}
                        onChange={this.onNextPageChange}
                      >
                        {this.getPages(pages, currentPage)}
                        <Option value="end">{I18n.l("formflow.labels.finishSection")}</Option>
                      </Select>
                    </div>
                  </>
                }
              </ConditionStyle>
              <ButtonStyle>
                <Row type="flex" justify="end">
                  <Button className="button-cancel" type="primary" ghost onClick={() => this.props.onCloseModal()} >{I18n.l('common.cancel')}</Button>
                  <Button className="button-save" type="primary" onClick={() => { this.onSaveCondition(updateProcessCondition) }} htmlType="submit" >{I18n.l('common.save')}</Button>
                </Row>
              </ButtonStyle>
            </Modal>
          )}
        </ProcessContext.Consumer>
      </Wrapper >
    );
  }
}

const Wrapper = styled.div``

const ConditionStyle = styled.div`
  font-family: Montserrat;;
  font-style: normal;
.item-container-condition{
    height: auto;
    background-color: white;
    border: 1px solid #D6DDF4;
    border-radius: 5px;
    text-align: left;
    padding: 30px 40px 30px 40px;
    margin-bottom: 1rem;
    box-shadow: 3px 2px 5px rgba(0, 0, 0, 0.15);
    .rules-conditions-box {
      height: auto;
      background-color: #EBF7F9;
      border-radius: 5px;
      text-align: left;
      padding: 30px 40px 30px 40px;
      margin-bottom: 1rem;
      margin-top: 1rem;
      font-size: 14px;
      color: #7E7E7E;
    }
    .divider-condition {
      border-top:  1px solid #D6DDF4;
      margin: 23px -40px 23px -40px;
    }
    .footer-condition-style {
      font-weight: bold;
      font-size: 14px;
      color: #7E7E7E;
    }
    .select-invalid {
      border: 1px solid red;
      border-radius: 4px;
    }
    .remove-conditions-style {
      cursor: pointer;
      float: right;
      line-height: 35px;
      font-weight: 500;
      font-size: 14px;
      color: #D93838;
    }
  }
  .choose-next-style {
    font-weight: bold;
    font-size: 14px;
    color: #7E7E7E;
  }
  .condition-title-style {
    font-weight: normal;
    font-size: 25px;
    color: #7E7E7E;
  }
  .cursor-page-style{
    cursor: pointer;
    width: 12rem;
    margin-top: -20px;
    background-color: #F6FBFF;
    position: relative;
    top: 20px;
    left: 44%;
    padding-left: 17px;
  }
  .add-new-rule-style{
    cursor: pointer;
    width: 21rem;
  }
.add-button-style {
    font-weight: 500;
    font-size: 14px;
    line-height: 42px;
    color: #8493AA;
}

`
const NextPageStyle = styled.div`
    font-family: Montserrat;;
    font-style: normal;
    .title-style {
      font-weight: bold;
      font-size: 40px;
      color: #587B99;
    }
    .name-page-style {
      font-weight: 500;
      font-size: 30px;
      color: #587B99;
    }
    .next-page-style {
      font-weight: 500;
      font-size: 14px;
      color: #595959;
      margin-top: 1.5rem;
    }
    .condition-description {
      font-weight: 500;
      font-size: 14px;
      color: #595959;
      width: 500px;
      padding-bottom: 1.5rem;
    }
    .ant-btn {
      color: #1890ff;
      background-color: #F6FBFF;
      border-color: #1890ff;
      border-radius: 50px;
      font-weight: bold;
      font-size: 12px;
      text-transform: uppercase;
}`
const Divider = styled.div`
    margin-top: 3rem;
    margin-bottom: 3rem;
    border-bottom:  2px solid #E5DFFC;
`;

const ButtonStyle = styled.div`
    float:right;
    padding-top: 50px;
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`
